import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import DynamicDataTable from '../../../components/DynamicDataTable/DynamicDataTable';
import UploadImage from '../../../assets/images/uploadImg.svg';
import Messages from '../../../shared/UI/Messages/Messages';
import axios from '../../../axios-url';


import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class RateCard extends Component {
    state = {
        roles: [],
        type: 'add',
        Id: null,
        UserId: null,
        EmployeeId: null,
        RoleId: null,
        functionalRoleId: [],
        functionalRoleOptions: [],
        approvalroles: [],
        approvalRoleId: null,
        UserId1: '',
        FirstName: '',
        MiddleName: '',
        LastName: '',
        EmailId: '',
        Password: '',
        MobileNumber: '',
        Activedirectory: false,
        Adloginid: '',
        Disablelogin: false,
        IsActive: false,
        createdBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
        createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail.CompanyId,
        touch: false
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('GeUsers?id=' + id);
        this.props.getMasterKeywordList('Role');
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('ApprovalRole');
        let type = this.props.match.params.type;

        axios.get('/master/api/DropDownValues/FRole')
            .then(response => {
                if (response.status === 200) {
                    let data = []
                    if (response.data && response.data.length > 0) {
                        data = response.data.map(list => {
                            let value = list.id;
                            let id = list.id;
                            let text = list.text
                            return { label: text, value: value.toString(), id: id };
                        })
                    }
                    this.setState({ functionalRoleOptions: data })
                }
            }
            )
            .catch(err => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Functional Roles Api Failed' });
            })

        if (type !== 'add') {
            this.timer();
        }
    }

    timer = () => {
        this.intervalID = setInterval(() => {
            this.fetchSingleProcess();
        }, 2000)
    }
    componentWillUnmount() {
        if (this.props.tableLists.usersList !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    fetchSingleProcess = () => {

        let id = this.props.match.params.id;
        let type = this.props.match.params.type;
        let storageItems = [];
        if (this.props.tableLists.usersList !== undefined) {
            storageItems = this.props.tableLists.users;
            clearInterval(this.intervalID);
        }
        if (storageItems) {
            let filterData = storageItems;
            if (filterData) {
                let roles = '';
                let functionalRoles = '';
                let approvalroles = '';
                if (filterData.roleAssigned != null) {
                    roles = filterData.roleAssigned.split(",")
                }
                if (filterData.functionalRole != null) {
                    functionalRoles = filterData.functionalRole.split(",")
                }
                if (filterData.approvalrole != null) {
                    approvalroles = filterData.approvalrole.split(",")
                }
                var data = {
                    type: type,
                    Id: filterData.id,
                    UserId: filterData.userId,
                    EmployeeId: filterData.employeeId,
                    RoleId: roles,
                    approvalRoleId: approvalroles,
                    UserId1: filterData.userid1,
                    FirstName: filterData.firstName,
                    functionalRoleId: functionalRoles,
                    MiddleName: filterData.middleName,
                    LastName: filterData.lastName,
                    EmailId: filterData.emailId,
                    Password: filterData.password,
                    MobileNumber: filterData.mobileNumber,
                    Activedirectory: filterData.activedirectory,
                    Adloginid: filterData.adloginid,
                    Disablelogin: filterData.disablelogin,
                    IsActive: filterData.isActive,
                    CreatedBy: filterData.createdby,
                    CreatedDate: filterData.createddate,
                }
                this.setState(data);

            }
        }

    }


    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true })

    }

    add = () => {

        if (this.state.EmployeeId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Employee is required' });
            return;
        } else if (this.state.RoleId === null || this.state.RoleId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Role is required' });
            return;
        }

        else if (this.state.UserId1 === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'UserName is required' });
            return;
        } else if (this.state.FirstName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'FirstName is required' });
            return;
        } else if (this.state.LastName === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'LastName is required' });
            return;
        } else if (this.state.EmailId === "" || this.state.EmailId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'EmailId is required' });
            return;
        } else if (this.state.Password === "") {
            this.growl.show({ severity: 'error', summary: null, detail: 'Password is required' });
            return;
        } else if (this.state.MobileNumber === "" || this.state.MobileNumber === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'MobileNumber is required' });
            return;
        } else if (this.state.approvalRoleId === "" || this.state.approvalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Approval Roleid is required' });
            return;
        } else if (this.state.functionalRoleId === "" || this.state.functionalRoleId === null) {
            this.growl.show({ severity: 'error', summary: null, detail: 'functional Roleid is required' });
            return;
        }
        var data = {
            EmployeeId: this.state.EmployeeId,
            RoleId: null,
            UserId1: this.state.UserId1,
            FirstName: this.state.FirstName,
            FunctionalRole: this.state.functionalRoleId.join(),
            Approvalrole: this.state.approvalRoleId.join(),
            MiddleName: this.state.MiddleName,
            LastName: this.state.LastName,
            EmailId: this.state.EmailId,
            Password: this.state.Password,
            MobileNumber: this.state.MobileNumber,
            RoleAssigned: this.state.RoleId.join(),
            Activedirectory: this.state.Activedirectory,
            Adloginid: this.state.Adloginid,
            Disablelogin: this.state.Disablelogin,
            IsActive: this.state.IsActive,
            CompanyId: this.state.CompanyId,
            CreatedBy: this.state.createdBy,
            CreatedDate: this.state.createdDate,
        }


        if (this.state.type === 'edit') {
            data.UserId = this.state.UserId;
            data.Id = this.state.Id
        }

        this.props.processDynamicData('user', this.state.type, data, 'GeUsers');

    }

    resetData = () => {
        var data = {
            UserId: null,
            EmployeeId: null,
            RoleId: null,
            functionalRoleId: null,
            approvalRoleId: null,
            UserId1: '',
            FirstName: '',
            MiddleName: '',
            LastName: '',
            EmailId: '',
            Password: '',
            MobileNumber: '',
            Activedirectory: false,
            Disablelogin: false,
            IsActive: false,
            type: 'add'
        }
        this.setState(data);
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/users/', this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) { this.props.history.push('/dashboard') }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess }

        let roleOptions = [];
        if (this.props.Role && this.props.Role.length > 0) {
            roleOptions = this.props.Role;
        }
        let approvalroleOptions = [];
        if (this.props.ApprovalRole && this.props.ApprovalRole.length > 0) {
            approvalroleOptions = this.props.ApprovalRole;
        }

        let isEnabled = (this.state.touch === true);

        let redirectURL = '/users/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = "/dashboard";
            }
        }

        const { id, name, label, value, placeholder, fieldStatus, onInputChange, disabled, style, metaData } = this.props;

        // const { name, label, value, placeholder, metaData, onInputChange, noLabel, disabled } = this.props;

        // Ensure value is always an array for MultiSelect
        let arrayValue = [];
        if (Array.isArray(value)) {
            arrayValue = value;
        } else if (typeof value === 'string' && value) {
            arrayValue = value.split(',').map(v => v.trim()).filter(v => v);
        }

        const fields = [
            {
                fieldName: '',
                fieldDescription: '',
                fieldType: 4,
                required: true,
                // options: [
                //     { label: '', value: 'checkbox' }
                // ]
            },
            {
                fieldName: 'Name',
                fieldDescription: 'Name',
                fieldType: 2,
                required: true
            },
            {
                fieldName: 'Unit',
                fieldDescription: 'Unit',
                fieldType: 2,
                required: true
            },
            {
                fieldName: 'Price',
                fieldDescription: 'Price',
                fieldType: 1,
                required: true
            },
            {
                fieldName: 'Tax Applicable',
                fieldDescription: 'Tax Applicable',
                fieldType: 4,
                required: true
            }
        ]

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />

                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1 style={{ marginBottom: '20px' }}>Rate Card Details</h1>

                        {/* Main Form Grid */}
                        <div className="p-grid">
                            {/* Rate Card Name & Active */}
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop" htmlFor="rateCardName">Rate Card Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText
                                        className="p-col-12"
                                        name="rateCardName"
                                        onChange={this.handleChange}
                                        value={this.state.rateCardName}
                                        placeholder="Rate Card Number"
                                    />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4" style={{ marginTop: '38px' }}>
                                <Checkbox
                                    name="isActive"
                                    inputId="isActive"
                                    onChange={(e) => this.setState({ isActive: e.checked, touch: true })}
                                    checked={this.state.isActive}
                                />
                                <label htmlFor="isActive" className="p-checkbox-label" style={{ marginLeft: '8px' }}>Active</label>
                            </div>

                            {/* Type - Supplier/Restaurant */}
                            <div className="p-col-12">
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <label className="labeltop" style={{ display: 'block', marginBottom: '8px' }}>Type <span className="requiredColor">*</span></label>
                                        <div className="p-grid" style={{ marginTop: '0.5em' }}>
                                            <div className="p-col-12 p-md-6">
                                                <RadioButton
                                                    value="supplier"
                                                    name="type"
                                                    onChange={event => this.setState({ type: 'supplier', selectedRestaurant: null })}
                                                    checked={this.state.type === 'supplier'}
                                                />
                                                <label htmlFor="typeSupplier" className="p-radiobutton-label" style={{ marginLeft: '8px' }}>Supplier</label>
                                            </div>
                                            <div className="p-col-12 p-md-6">
                                                <RadioButton
                                                    value="restaurant"
                                                    name="type"
                                                    onChange={event => this.setState({ type: 'restaurant', selectedSupplier: null })}
                                                    checked={this.state.type === 'restaurant'}
                                                />
                                                <label htmlFor="typeRestaurant" className="p-radiobutton-label" style={{ marginLeft: '8px' }}>Restaurant</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Dynamic Field based on Type selection */}
                            {this.state.type === 'supplier' && (
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                        Supplier <span className="requiredColor">*</span>
                                    </label>
                                    <MultiSelect
                                        className="p-col-12"
                                        options={this.props.supplierOptions || []}
                                        value={this.state.selectedSupplier || []}
                                        onChange={(e) => this.setState({ selectedSupplier: e.value, touch: true })}
                                        placeholder="Please select supplier"
                                        name="selectedSupplier"
                                        filter={true}
                                        display="chip"
                                        style={{ width: '100%' }}
                                        {...DROPDOWN_CONFIG}
                                    />
                                </div>
                            )}

                            {this.state.type === 'restaurant' && (
                                <div className="p-col-12 p-md-6 p-lg-4">
                                    <label className="labeltop" style={{ display: 'block', marginBottom: '8px', fontWeight: '600' }}>
                                        Restaurant <span className="requiredColor">*</span>
                                    </label>
                                    <MultiSelect
                                        className="p-col-12"
                                        options={this.props.restaurantOptions || []}
                                        value={this.state.selectedRestaurant || []}
                                        onChange={(e) => this.setState({ selectedRestaurant: e.value, touch: true })}
                                        placeholder="Please select restaurant"
                                        name="selectedRestaurant"
                                        filter={true}
                                        display="chip"
                                        style={{ width: '100%' }}
                                        {...DROPDOWN_CONFIG}
                                    />
                                </div>
                            )}

                            {/* Category - Always visible */}
                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop">Category <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown
                                        className="p-col-12"
                                        options={this.props.categoryOptions || []}
                                        value={this.state.categoryId}
                                        onChange={this.handleChange}
                                        placeholder="All Category"
                                        name="categoryId"
                                        {...DROPDOWN_CONFIG}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Raw Material Details Section */}
                        <div className="p-col-12" style={{ marginTop: '30px' }}>
                            <div className="card card-w-title">
                                <h1>Raw Material Details</h1>

                                <DynamicDataTable


                                    fields={fields}
                                    metaData={metaData}
                                    rows={this.state.fromRawMaterialRows}
                                    onRowsChange={(rows) => this.setState({ fromRawMaterialRows: rows })}
                                    addNewLabel="Add New"
                                    clearAllLabel="Clear All"
                                    removeLabel="Remove"
                                    onCellChange={(rowIndex, fieldIndex, value, row) => {
                                        // Handle cell changes including checkbox
                                        const updatedRows = [...this.state.fromRawMaterialRows];
                                        updatedRows[rowIndex] = { ...row, [fields[fieldIndex].fieldName]: value };
                                        this.setState({ fromRawMaterialRows: updatedRows });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        GetEmployeedropdown: (state.keyword.Employee !== undefined) ? state.keyword.Employee : [],
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        Role: (state.keyword.Role !== undefined) ? state.keyword.Role : [],
        ApprovalRole: (state.keyword.ApprovalRole !== undefined) ? state.keyword.ApprovalRole : [],
        tableLists: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RateCard);